module.exports = __webpack_public_path__ + "static/media/how_does_it_work.1ca39c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/how_does_it_work.png
// module id = 87
// module chunks = 0